import * as React from "react";
import { useEffect, useState } from "react";
export const ScrollToTop = (): JSX.Element => {
    const [visible, setVisible] = useState(false);

    const handleScroll = () => {
        setVisible(window.scrollY > 200);
    };
    const scrollToTop = () => {
        window.scrollTo({
            top : 0,
            behavior : "smooth",
        });
    };
    useEffect(() => {
        window.addEventListener("scroll", handleScroll);
        return () => window.removeEventListener("scroll", handleScroll);
    }, []);
    return (
        <div id="scroll-to-top" className={visible ? "shown" : ""}>
            <button onClick={scrollToTop} title="Scroll to top">
                <i className="icon-arrow"></i>
            </button>
      </div>
    );
};